/* eslint-disable react/prop-types */
import React, { useContext } from 'react'

import { ThemeContext } from '@cred/react-theme'

import {
  BANKRATE,
  NERDWALLET,
  VERTICAL_NAME_MAP,
  WSJ,
} from 'components/featured-lender-banner/const'
import WidgetContext from 'components/widget-context'

import nerdwalletIcon from '../assets/nerdwallet-icon.svg'
import { ReactComponent as BankrateIcon } from '../assets/bankrate-icon.svg'
import styles from './styles.module.scss'

const currentYear = new Date().getFullYear()

const NerdwalletBestBanner = ({ vertical }) => (
  <div className={`${styles.bestBanner} ${styles.nerdwallet}`}>
    <img className={styles.partnerIcon} src={nerdwalletIcon} alt="nerdwallet-icon" />
    <p>
      2024 best {VERTICAL_NAME_MAP[vertical]} <span>overall</span>
    </p>
  </div>
)

const BankrateBestBanner = ({ vertical }) => (
  <div className={`${styles.bestBanner} ${styles.bankrate}`}>
    <BankrateIcon className={styles.partnerIcon} />
    <p>2024 best {VERTICAL_NAME_MAP[vertical]} overall</p>
  </div>
)

const WsjBestBanner = ({ vertical }) => (
  <div className={`${styles.bestBanner} ${styles.wsj}`}>
    {currentYear} best {VERTICAL_NAME_MAP[vertical]}
  </div>
)

const componentMap = {
  [NERDWALLET]: NerdwalletBestBanner,
  [WSJ]: WsjBestBanner,
  [BANKRATE]: BankrateBestBanner,
}

// eslint-disable-next-line react/prop-types
const BestBaner = ({ shouldShow }) => {
  const theme = useContext(ThemeContext)
  const { vertical } = useContext(WidgetContext)

  const BestBannerComponent = componentMap[theme]

  return shouldShow && BestBannerComponent ? <BestBannerComponent vertical={vertical} /> : null
}

export default BestBaner
